/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVectorLine: {
  name: 'vector-line';
  data: string;
} = {
  name: 'vector-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2c-.18 0-.353-.024-.518-.068l-11.55 11.55c.044.165.068.339.068.518v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2c.18 0 .353.024.518.068l11.55-11.55A2.006 2.006 0 0 1 17 5V3Zm4 0h-2v2h2V3ZM5 19H3v2h2v-2Z" fill="currentColor"/></svg>`,
};
